import { Phone } from "lucide-react";

export const WHATSAPP_URL = "https://wa.me/34623368344";

export const WhatsAppContact = ({ text, compact = false, highlight = false }) => (
  <div className={compact ? "px-2 py-2" : "rounded-xl border border-border bg-card p-4 text-center"} data-testid="whatsapp-contact">
    {text && <p className={`leading-snug mb-2 ${highlight ? "text-muted-foreground font-bold" : "text-muted-foreground"} ${compact ? "text-xs" : "text-sm"}`} data-testid="whatsapp-contact-text">{text}</p>}
    <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer"
      className={`inline-flex items-center gap-1.5 rounded-md border border-border bg-background text-muted-foreground hover:bg-accent hover:text-foreground transition-colors ${highlight ? "font-normal opacity-80" : "font-medium"} ${compact ? "px-2.5 py-1.5 text-xs" : "px-4 py-2 text-sm"}`}
      data-testid="whatsapp-contact-link"><Phone className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} /> +34623368344</a>
  </div>
);
